import { render, staticRenderFns } from "./EscalaRamsay.vue?vue&type=template&id=59681057&"
import script from "./EscalaRamsay.vue?vue&type=script&lang=js&"
export * from "./EscalaRamsay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports